export { default as Bitacora } from './Listar';
export { default as DetalleBitacora } from './Detalle';
